var cilMediaSkipForward = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M32,111.882V400.118A23.979,23.979,0,0,0,70.285,419.4L248,287.763V400.118A23.979,23.979,0,0,0,286.285,419.4l194.56-144.119a24,24,0,0,0,0-38.57L286.285,92.6A24,24,0,0,0,248,111.882V224.237L70.285,92.6A24,24,0,0,0,32,111.882Zm248,15.881L453.119,256,280,384.237Zm-216,0L237.119,256,64,384.237Z' class='ci-primary'/>"];

export { cilMediaSkipForward };

